<template lang="pug">
	
	.badass-origins-intro

		.spray-wrapper(ref='sprayWrapper')
			.spray-movable(ref='movable')
				img(src="assets/images/painting-background.jpg" ref='background' class='bg-paint')

				.spray(ref='spray')
		
		.title(ref='title')
			h2(v-html="translate('badass.title')")

		splited-text(ref="splitedText" :text="text")

		

</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import { TweenMax } from 'gsap'
	import Scrollable from '~abstracts/scrollable'
	import Globals from '~utils/Globals.js'
	import SplitedText from '~components/splited-text.vue'
	import * as PIXI from 'pixi.js'

	import bg from 'assets/images/badass-origins-intro.jpg'
	import maskImg from 'assets/sprites/spray-bw.png'
	import maskJson from 'assets/sprites/spray-bw.json'

	import BackgroundTools from '~utils/coverBackground.js'
	import _ from 'lodash'

  	@Component({
		name: 'BadassOriginsIntro',
		components: { SplitedText },
		data : function () {
			return {
				state : Globals.state,
				text : "",
				animOffset : 500
			}
		},
		computed : {
			isMobile: function () {
				return this.state.isMobile
			},
			isTablet: function () {
				return this.state.isTablet
			}
		}
	})

	class BadassOriginsIntro extends Scrollable {
		
		created () {
			this.text = this.translate('badass.about')
			this.title = this.translate('badass.title')
		}

		mounted () {
			super.mounted()

					

			this._dom()
		}

		init () {
			super.init()


			this.currentFrame = null
			this.currentIndex = null

			this.app = new PIXI.Application(window.innerWidth, window.innerHeight,{
				transparent: true,
				antialias: true
			})

			this.app.renderer.autoResize = true
			this.$refs.spray.appendChild(this.app.view)


			PIXI.loader
				.reset()
				.add('bg', bg)
				.add('spray-bw', maskImg)
				.load(this.loaded)

		}

		createTitle () {

			let title = new PIXI.Text(this.title,{fontFamily : 'Poppins', fontSize: 100, fontWeight:700, fill : 0xffffff, align : 'center'});
			
			title.position.x = window.innerWidth/2
			title.anchor.set(0.5)
			// title.alpha = 0

			return title
		}

		loaded(loader, resources){

			this.bg = PIXI.Sprite.fromImage(bg)

			this.imageContainer = new PIXI.Container()
			this.spriteContainer = new PIXI.Container()	

			this.titleCanvas = this.createTitle()

			
			this.imageContainer.addChild(this.bg)
			this.imageContainer.addChild(this.titleCanvas)
			var maskSprite = new PIXI.Spritesheet(resources['spray-bw'].texture.baseTexture, maskJson)
			
			this.app.stage.addChild(this.imageContainer)

			maskSprite.parse(w => {									
				this.mask = Object.values(maskSprite.textures)				
				this.maskImage(0)			
				this._resize()							
			})	
		}

		_bind () {
			super._bind()
		}

		_dom () {
		
		}

		redimensionate = (element, size = null) => {
			if(!element) return 

			const sizes = size ? size : {w: window.innerWidth, h: window.innerHeight}
			const dimension = BackgroundTools.Cover(element.width,element.height,sizes.w,sizes.h)

			element.width = dimension.w
			element.height = dimension.h
			element.position.x = dimension.pos.x
			element.position.y = dimension.pos.y		
		}

		initTimeline () {
			super.initTimeline()

			// this.tl = new TimelineMax({onReverseComplete: ()=>{
			// 	console.log('end reverse')
			// 	TweenMax.set(this.bg,{alpha:1})
			// 	TweenMax.set(this.$refs.background,{opacity:1},0)
			// }})

			if(this.bg) {
				this.tl.set(this.bg,{alpha:1, onComplete:()=>{
				}},0)
				this.tl.set(this.$refs.background,{opacity:1},0)
			}

			const whRatio = window.innerHeight/(this.animOffset+window.innerHeight)

			this.tl.fromTo(this.$refs.sprayWrapper,whRatio,{scale:1.05,y:-window.innerHeight*.3},{scale:1,y:0, ease: Power0.easeNone},0)
			this.tl.fromTo(this.$refs.movable,1-whRatio,{y:0},{y:this.animOffset, ease: Power0.easeNone},whRatio)
	
			if(this.titleCanvas){

				const fromTop = this.$refs.title.getBoundingClientRect().top - this.bounds.top - this.scroller.scroll.position + this.$refs.title.getBoundingClientRect().height / 2
				const toTop = this.$refs.title.getBoundingClientRect().top - this.bounds.top - this.scroller.scroll.position - this.animOffset + this.$refs.title.getBoundingClientRect().height / 2
				
				// console.log(this.$refs.title.getBoundingClientRect().top)
				// console.log(fromTop)
				// console.log(toTop)

				this.tl.fromTo(this.titleCanvas.position,1-whRatio,{x:window.innerWidth/2, y:fromTop},{y:toTop, ease: Power0.easeNone},whRatio)
			}
		
			if(this.bg) {
				this.tl.set(this.bg,{alpha:0},0.999999)
				this.tl.set(this.$refs.background,{opacity:0},0.999999)
				this.tl.add(()=>{

					if(this.scroller.direction == 1 || this.isResized == false) {
						this.$refs.splitedText.animateIn()
					} else {
						this.$refs.splitedText.animateOut()
					}
					this.isResized = true
				},0.8)
			}

		}


		raf (y) {
			super.raf(y)

			if(!this.mask) return
			if(!this.isInViewport) return

			const whRatio = Globals.height/(this.animOffset+Globals.height)

			const sprayBounds = {
				top: this.bounds.top,
				bottom: this.bounds.top + this.animOffset
			}

			let i = Math.floor(30*(this.scroller.getPerc(sprayBounds, y)) * .8)
			this.maskImage(i)

		}

		maskImage (i) {
			let frame = this.getMaskFrame(i)
			frame.name = 'frame-'+i

			if( i === this.currentIndex) return false

			this.imageContainer.removeChild(this.currentFrame)

			this.imageContainer.mask = frame
			this.imageContainer.addChild(frame)

			this.currentFrame = frame
			this.currentIndex = i
		}

		_resize () {
			super._resize()

			this.app && this.app.renderer.resize(window.innerWidth, window.innerHeight)

			this.bounds.height = window.innerHeight + this.animOffset
			this.$el.style.height = this.bounds.height + "px"

			this.boundsAnim = {
				top: this.bounds.top - window.innerHeight,
				bottom: this.bounds.top + this.animOffset
			}

			this.redimensionate(this.bg)

			this.initTimeline()
		}


		getMaskFrame (i) {
			let frame = new PIXI.Sprite(this.mask[i])
			this.redimensionate(frame)

			return frame
		}

		_on () {
			super._on()
		}

		_off () {
			super._off()
			
		}

	}

	export default BadassOriginsIntro

</script>


<style lang="stylus">
	
	@import '../../../theme/utils'
	@import '../../../theme/variables'
	
	.badass-origins-intro
		width 100%
		position relative
		padding-top 100vh

		.spray-wrapper
			position absolute
			top 0
			left 0
			width 100%

			.spray-movable
				position relative
				height 100vh
				width 100%
				overflow hidden

			.spray
				position absolute
				top 0
				left 0
				width 100%
				height 100%

				canvas
					height 100%
					width 100%

			.bg-paint
				height 100%
				width 100%
				object-fit cover

		.title
			width 100%
			padding 0 10vw
			text-align center
			position relative
			z-index 80
			margin-bottom 8%
			opacity 1
			
			+break(xs)
				padding 0

			h2
				color #fff
				font-size em(100px)
				font-weight 700
				color red !important
				opacity 0

				+break(xs)
					font-size em(80px)

		.splited-text
			max-width 700px
			margin auto
			text-align center

			+break(minlg)
				max-width 1000px

	
</style>


// WEBPACK FOOTER //
// badass-origins-intro.vue?46247113